/**
 * A domain enumok magyar megjelenítési szövegei — EGY helyen.
 *
 * Ugyanaz a minta, mint az `ERROR_TITLE_HU`-nál: `Record<Enum, string>`,
 * tehát egy új enumérték felvétele TÍPUSHIBA, amíg nincs magyar szövege.
 * Enélkül a felületen csendben a nyers kódnév jelenne meg (`PALLET_LEVEL_
 * REOPENED`), amit a felhasználó nem tud értelmezni.
 *
 * A spec 17.1 §-a magyar nyelvű felületet ír elő, és ezek a szövegek több
 * képernyőn is megjelennek (eseménynapló, adatlapok, címkekonzol), ezért
 * nem képernyőnként definiáljuk őket.
 *
 * Megjegyzés: az Android ugyanezt Kotlinban tartja
 * (`feature/shared/Labels.kt`), mert TS-t nem tud importálni — ez tudatosan
 * vállalt duplikáció. A TS oldal viszont buktatja a buildet egy hiányzó
 * címkénél, míg a Kotlin `else ->` ága csendben a nyers kódot írná ki.
 */
export const EVENT_TYPE_LABEL_HU = {
    FOLDER_CREATED: 'Mappa regisztrálva',
    FOLDER_IMAGE_ADDED: 'Fotó hozzáadva',
    FOLDER_IMAGE_PRIMARY_CHANGED: 'Elsődleges fotó módosítva',
    FOLDER_IMAGE_DELETED: 'Fotó törölve',
    LOCAL_OCR_COMPLETED: 'Helyi felismerés kész',
    AI_RECOGNITION_REQUESTED: 'Azure felismerés indítva',
    AI_RECOGNITION_COMPLETED: 'Azure felismerés kész',
    FOLDER_TEXT_UPDATED: 'Gerincszöveg módosítva',
    FOLDER_SPINE_FIELDS_UPDATED: 'Gerincadatok kézzel javítva',
    COMPANY_CREATED: 'Cég felvéve',
    COMPANY_UPDATED: 'Cég módosítva',
    SPINE_IGNORE_PATTERN_CREATED: 'Kihagyandó minta felvéve',
    SPINE_IGNORE_PATTERN_UPDATED: 'Kihagyandó minta módosítva',
    SPINE_REPARSED: 'Gerincadatok újraelemezve',
    FOLDER_LOCATION_CHANGED: 'Áthelyezve',
    FOLDER_ASSIGNED_TO_PALLET: 'Raklapra rakva',
    FOLDER_REMOVED_FROM_PALLET: 'Levéve a raklapról',
    PALLET_CREATED: 'Raklap létrehozva',
    LOCATION_LEVEL_ADDED: 'Szint hozzáadva',
    LOCATION_LEVEL_REMOVED: 'Szint törölve',
    LOCATION_LEVEL_LOCKED: 'Polcszint lezárva',
    LOCATION_LEVEL_UNLOCKED: 'Polcszint feloldva',
    // A megszűnés OKA benne van a szövegben: a kézi törléstől
    // (`LOCATION_LEVEL_REMOVED`) csak így különböztethető meg a naplóban.
    PALLET_LEVEL_COLLAPSED: 'Szint megszűnt (kiürült)',
    PALLET_BULK_ASSIGNMENT_COMPLETED: 'Tömeges feltöltés lezárva',
    PALLET_LEVEL_DISMANTLED: 'Szint felbontva',
    PALLET_DISMANTLED: 'Raklap felbontva',
    PALLET_STATUS_CHANGED: 'Raklap státusza módosult',
    LOCATION_CREATED: 'Lokáció létrehozva',
    LOCATION_STATUS_CHANGED: 'Lokáció státusza módosult',
    PRINTER_CREATED: 'Nyomtató felvéve',
    PRINTER_UPDATED: 'Nyomtató módosítva',
    LABEL_ALLOCATION_RESTORED: 'Selejtezett sorszám visszaadva',
    LABEL_BATCH_ALLOCATED: 'Címkeköteg lefoglalva',
    LABEL_BATCH_PRINT_SENT: 'Címkeköteg nyomtatásra küldve',
    LABEL_BATCH_PRINT_FAILED: 'Címkeköteg nyomtatása sikertelen',
    LABEL_BATCH_RESENT: 'Címkeköteg újraküldve',
    LABEL_BATCH_CONFIRMED: 'Címkeköteg megerősítve',
    LABEL_BATCH_VOIDED: 'Címkeköteg selejtezve',
    LABEL_REPRINTED: 'Címke újranyomtatva',
};
export const LOCATION_TYPE_LABEL_HU = {
    PALLET: 'Raklap',
    SHELF: 'Polc',
    STORAGE: 'Tároló',
};
export const LOCATION_STATUS_LABEL_HU = {
    ACTIVE: 'Aktív',
    INACTIVE: 'Inaktív',
};
export const FOLDER_STATUS_LABEL_HU = {
    CAPTURED: 'Fotózva',
    OCR_PENDING: 'Felismerés folyamatban',
    REVIEW_REQUIRED: 'Ellenőrzés szükséges',
    APPROVED: 'Jóváhagyva',
    ARCHIVED: 'Archiválva',
};
export const PALLET_STATUS_LABEL_HU = {
    OPEN: 'Nyitva',
    CLOSED: 'Lezárva',
    IN_TRANSIT: 'Szállítás alatt',
    STORED: 'Tárolva',
    EMPTY: 'Üres',
    DISMANTLED: 'Felbontva',
};
// A `PALLET_LEVEL_STATUS_LABEL_HU` megszűnt a `PalletLevelStatus` enummal
// együtt (D fázis): a szinteknek nincs többé nyitott/zárt állapota.
export const RECOGNITION_TYPE_LABEL_HU = {
    LOCAL_OCR: 'Helyi felismerés',
    AZURE_AI: 'Azure AI',
};
export const RECOGNITION_STATUS_LABEL_HU = {
    QUEUED: 'Sorban áll',
    RUNNING: 'Fut',
    COMPLETED: 'Kész',
    FAILED: 'Sikertelen',
};
export const SOURCE_CLIENT_LABEL_HU = {
    ZEBRA: 'Zebra',
    WEB: 'Web',
    SYSTEM: 'Rendszer',
};
export const EVENT_RESULT_LABEL_HU = {
    SUCCESS: 'Sikeres',
    FAILURE: 'Sikertelen',
};
export const ACCESSIBILITY_LABEL_HU = {
    EASY: 'Könnyen elérhető',
    MEDIUM: 'Közepesen elérhető',
    HARD: 'Nehezen elérhető (alsó szint)',
};
/**
 * A nyomtatási státusz ADAT, nem hiba (ld. `LabelPrintStatus` doc-comment).
 * A szövegek ezért nem hibaüzenetek, hanem tényállítások — a következő
 * lépést a szerver `hint` mezője mondja meg, nem ezek.
 */
export const LABEL_PRINT_STATUS_LABEL_HU = {
    PENDING: 'Feldolgozás alatt',
    SENT: 'Nyomtatóra küldve',
    UNCONFIRMED: 'Bizonytalan (időtúllépés)',
    FAILED: 'Nyomtatás sikertelen',
    CONFIRMED: 'Megerősítve',
    NOT_PRINTED: 'Nem nyomtatva (csak foglalás)',
};
export const LABEL_KIND_LABEL_HU = {
    FOLDER: 'Mappacímke',
    PALLET: 'Raklapcímke',
    SHELF: 'Polccímke',
    STORAGE: 'Tárolócímke',
};
/**
 * A címkére NYOMTATOTT típusmegnevezés (D fázis, 3.3 pont).
 *
 * Külön a `LABEL_KIND_LABEL_HU`-tól, mert más a szerepük: az a FELÜLETEN
 * jelenik meg („Mappacímke" mint kötegtípus), ez pedig a FIZIKAI címkén, a
 * rendszernév után („Persped Irattár - Mappa"). A kettő szándékosan
 * eltérő szövegű: a címkén az OBJEKTUM neve kell, nem a címkéé.
 *
 * A hossz itt kontraktus: a leghosszabb változat szabja meg a betűméretet,
 * és a `zpl.spec.ts` szélesség-ellenőrzése erre épül.
 *
 * A mappacímke felirata SZÁNDÉKOSAN maradt „Persped Irattár - Mappa"
 * (2026-08-14). Felmerült, hogy a `Persped` szó elhagyásával ne zavarja a
 * fotóból induló cégfelismerést — de az csak az EZUTÁN nyomtatott
 * címkéken segítene, a már felragasztottakon nem. A valódi megoldás a
 * parser oldalán van: a kihagyandó minták (G3) a teljes feliratot vonják
 * ki, mielőtt a cégillesztés elindulna.
 */
export const LABEL_TYPE_ON_LABEL_HU = {
    FOLDER: 'Mappa',
    PALLET: 'Raklap',
    SHELF: 'Polc',
    STORAGE: 'Tároló',
};
// A `COMPANY_LABEL_HU` MEGSZŰNT (F1): a cégnév az adatbázisból jön
// (`company.name`), mert a lista adminisztrálható lett. A web a
// `useCompanies()` hookkal tölti be; a `Record<Company, string>` fordítási
// idejű teljességi garanciája ezzel elveszett — ez az ára annak, hogy egy
// új cég felvétele ne legyen kitelepítés.
/** A gerincen szereplő irattípus magyar megjelenítése (C3). */
export const DOCUMENT_TYPE_LABEL_HU = {
    BEVALLASOK: 'Bevallások',
    PENZTAR: 'Pénztár',
    LELTAR: 'Leltár',
    FOKONYVI_KARTONOK: 'Főkönyvi kartonok',
    BEERKEZETT_SZAMLAK: 'Beérkezett számlák',
    KIMENO_SZAMLAK: 'Kimenő számlák',
    TARGYI_ESZKOZ_KARTONOK: 'Tárgyi eszköz kartonok',
    OSREVIZIO: 'Ősrevízió',
    FORRASOK: 'Források',
    EGYEB: 'Egyéb',
};
/** Pénznem a gerincen (C3). */
export const SPINE_CURRENCY_LABEL_HU = {
    HUF: 'Forint',
    EUR: 'Euró',
};
//# sourceMappingURL=labels.js.map